<!-- vertical layout -->
<app-vertical-layout [layoutWidth]="layoutWidth">
</app-vertical-layout>
<ngx-spinner name="global"  bdColor = "rgba(0, 0, 0, 0.9)" size = "medium" color = "#fff" type = "square-jelly-box" [fullScreen] = "true"><p style="color: white" > Ładuje... </p></ngx-spinner>

<!-- "What's new" announcement modal -->
<ng-template #whatsNewModal let-modal>
    <div class="whats-new">
        <button type="button" class="whats-new__close" aria-label="Zamknij" (click)="modal.dismiss()">
            <i class="fi fi-rr-cross-small"></i>
        </button>

        <div class="whats-new__hero">
            <div class="whats-new__badge"><i class="fi fi-rr-rocket"></i> Aktualizacja</div>
            <h3 class="whats-new__title">Co nowego w Fodimi?</h3>
            <p class="whats-new__subtitle">
                Kolejna porcja nowości — od kuchni i wydawki, przez magazyn i uprawnienia pracowników,
                po stronę internetową i aplikację mobilną. Oto najważniejsze zmiany:
            </p>
        </div>

        <div class="whats-new__body">
            <div class="whats-new__item">
                <div class="whats-new__icon"><i class="fi fi-rr-hat-chef"></i></div>
                <div class="whats-new__text">
                    <h5>Wydawka i czasy kuchni w KDS</h5>
                    <p>Jeśli korzystasz z Fodimi KDS, ekran możesz ustawić jako wydawkę — widzi, które części zamówienia
                        są już gotowe na poszczególnych stanowiskach. W raportach doszedł raport Kuchnia z czasem
                        przygotowania dań i całych zamówień.</p>
                    <a href="https://pomoc.fodimi.pl/fodimi-kds/ekran-wydawki-w-fodimi-kds" target="_blank" rel="noopener">
                        Zobacz, jak to działa <i class="fi fi-rr-arrow-small-right"></i>
                    </a>
                </div>
            </div>

            <div class="whats-new__item" *ngIf="hasInventory">
                <div class="whats-new__icon"><i class="fi fi-rr-truck-side"></i></div>
                <div class="whats-new__text">
                    <h5>Dostawy na WZ i faktura zbiorcza</h5>
                    <p>Dostawy przyjęte na WZ — także w aplikacji Fodimi Magazyn — rozliczysz potem jedną fakturą
                        zbiorczą. Fakturę zakupową dodasz też ręcznie, razem z plikiem.</p>
                    <a href="https://pomoc.fodimi.pl/magazyn/dostawy-na-wz-i-faktura-zbiorcza" target="_blank" rel="noopener">
                        Zobacz, jak to działa <i class="fi fi-rr-arrow-small-right"></i>
                    </a>
                </div>
            </div>

            <div class="whats-new__item" *ngIf="hasInventory">
                <div class="whats-new__icon"><i class="fi fi-rr-calculator"></i></div>
                <div class="whats-new__text">
                    <h5>Wycena składników i spis z natury</h5>
                    <p>Wybierz, jak wyceniać składniki: średnia z 90 dni, z 30 dni albo cena z ostatniej faktury.
                        Spis z natury zrobisz też z liczenia z innego dnia — stany przeliczą się na dzień spisu.</p>
                    <a href="https://pomoc.fodimi.pl/magazyn/metoda-wyceny-skladnikow" target="_blank" rel="noopener">
                        Zobacz, jak to działa <i class="fi fi-rr-arrow-small-right"></i>
                    </a>
                </div>
            </div>

            <div class="whats-new__item">
                <div class="whats-new__icon"><i class="fi fi-rr-users-alt"></i></div>
                <div class="whats-new__text">
                    <h5>Własne szablony uprawnień</h5>
                    <p>Zapisz zestaw uprawnień jako szablon (np. „Kierownik zmiany”) i nadawaj go kolejnym
                        pracownikom jednym kliknięciem.</p>
                    <a href="https://pomoc.fodimi.pl/pracownicy/wlasne-szablony-uprawnien-pracownikow" target="_blank" rel="noopener">
                        Zobacz, jak to działa <i class="fi fi-rr-arrow-small-right"></i>
                    </a>
                </div>
            </div>

            <div class="whats-new__item">
                <div class="whats-new__icon"><i class="fi fi-rr-globe"></i></div>
                <div class="whats-new__text">
                    <h5>Strona internetowa z gotowego szablonu</h5>
                    <p>100 gotowych szablonów stron dla różnych typów lokali oraz nowe style kategorii i produktów
                        w menu zamówień online.</p>
                    <a href="https://pomoc.fodimi.pl/strona-internetowa/jak-stworzyc-strone-internetowa-z-gotowego-szablonu" target="_blank" rel="noopener">
                        Zobacz, jak to działa <i class="fi fi-rr-arrow-small-right"></i>
                    </a>
                </div>
            </div>

            <div class="whats-new__item">
                <div class="whats-new__icon"><i class="fi fi-rr-mobile-notch"></i></div>
                <div class="whats-new__text">
                    <h5>Prostszy kreator aplikacji mobilnej</h5>
                    <p>Kreator krok po kroku pokazuje, czego jeszcze brakuje do publikacji aplikacji w sklepach —
                        od menu, przez dokumenty prawne, po opis w sklepie.</p>
                </div>
            </div>
        </div>

        <div class="whats-new__footer">
            <button type="button" class="btn btn-primary btn-lg whats-new__cta" (click)="modal.close()">
                Świetnie, zaczynam!
            </button>
        </div>
    </div>
</ng-template>
